import type { AgenticIntegration } from "@p0security/integrations-agentic-shared/components";
import type { FrontendInstallContext } from "@p0security/integrations-installer";
import { otherInstalled } from "@p0security/shared/install/options";
import { Link } from "react-router-dom";

const installedGateways = otherInstalled<AgenticIntegration>("gateway");

export const agenticGatewayFieldInstaller = {
  optionProvider: installedGateways,
  prerequisiteMessages: async (
    context: FrontendInstallContext<AgenticIntegration>
  ) => {
    if (!(await installedGateways(context)).length)
      return (
        <div>
          Requires installed &quot;<Link to={"./gateway"}>Gateway</Link>&quot;
          component
        </div>
      );
  },
};

export const agenticLogProviderFieldInstaller = {
  optionProvider: otherInstalled<AgenticIntegration>("log-provider"),
};
